import React from 'react';

export function ReviewPriceComponent({count = null}) {
    if (count) {
        return (
            <span className={'CommonRatioCard__footer__reviewcount'}>
                {`(${count})`}
            </span>
        );
    }
    return null;
}

export default ReviewPriceComponent;
